import { render, staticRenderFns } from "./MedicinesTable.vue?vue&type=template&id=6641fc5c&"
import script from "./MedicinesTable.vue?vue&type=script&lang=js&"
export * from "./MedicinesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports